import React from 'react';
import { Field } from 'formik';

const AdhesionAMAIRGratuite = ({ formikProps }) => {
  const { errors, touched } = formikProps;

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h3 className="text-lg font-medium leading-6 text-gray-900">
          Adhésion à l'AMAIR
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Profitez de l'adhésion gratuite à l'AMAIR
        </p>
      </div>

      <div className="bg-honey-50 border border-honey-200 rounded-lg p-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-honey-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-honey-800">
              Avantage adhérent SAR
            </h3>
            <div className="mt-2 text-sm text-honey-700">
              <p>
                En tant qu'adhérent SAR, vous pouvez bénéficier de l'adhésion gratuite à l'AMAIR (Association de la Maison de l'Apiculture de l'Île de la Réunion).
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <div className="flex items-start">
            <div className="flex items-center h-5">
              <Field
                type="checkbox"
                id="adhesionAMAIRGratuite"
                name="adhesionAMAIRGratuite"
                className="h-4 w-4 rounded border-gray-300 text-honey-600 focus:ring-honey-500"
              />
            </div>
            <div className="ml-3">
              <label htmlFor="adhesionAMAIRGratuite" className="text-base font-medium text-gray-900">
                Oui, je souhaite adhérer à l'AMAIR
              </label>
              <p className="text-sm text-gray-500 mt-1">
                L'adhésion à l'AMAIR est gratuite pour tout adhérent au SAR (valeur 50€).
                Votre adhésion à l'AMAIR sera effective dès que votre adhésion au SAR sera validée et payée.
              </p>
            </div>
          </div>
          {errors.adhesionAMAIRGratuite && touched.adhesionAMAIRGratuite && (
            <p className="mt-2 text-sm text-red-600">{errors.adhesionAMAIRGratuite}</p>
          )}
        </div>

        <div className="bg-gray-50 rounded-lg p-4">
          <h4 className="text-sm font-medium text-gray-900 mb-2">
            Ce que vous obtenez avec l'AMAIR :
          </h4>
          <ul className="space-y-2 text-sm text-gray-700">
            <li className="flex items-start">
              <svg className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Accès aux services de la Maison de l'Apiculture</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdhesionAMAIRGratuite;
